export default __webpack_public_path__ + "static/blue-bg-7a78e31a70237cc01d267bec4d5aebb5.png";